import { useEffect, useState } from 'react';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { Link, SidebarItem, useSidebarOpenState } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import { manewcoTokens } from '@platform/plugin-platform-react';

const useStyles = makeStyles(theme => {
  const MANEWCO = manewcoTokens(theme);
  return {
    user: {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      margin: '10px 16px 12px',
      padding: '15px 10px 4px',
      borderTop: `1px solid ${MANEWCO.line}`,
      color: MANEWCO.text,
      textDecoration: 'none',
    },
    avatar: {
      width: 34,
      height: 34,
      borderRadius: '50%',
      flexShrink: 0,
      display: 'grid',
      placeItems: 'center',
      backgroundColor: MANEWCO.pale,
      color: MANEWCO.primary,
      fontSize: 11,
      fontWeight: 700,
    },
    text: { minWidth: 0, fontSize: 11, lineHeight: 1.4 },
    name: { fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
    email: { color: MANEWCO.textSecondary, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  };
});

/** « Admin MaNewCo » → « AM ». */
const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(w => w[0]!.toUpperCase())
    .join('');

/** Bas du menu (maquette) : initiales, nom et e-mail de l'utilisateur, vers « Mon profil ». */
export const SidebarUser = () => {
  const classes = useStyles();
  const identityApi = useApi(identityApiRef);
  const { isOpen } = useSidebarOpenState();
  const [profile, setProfile] = useState<{ displayName?: string; email?: string }>({});

  useEffect(() => {
    let cancelled = false;
    identityApi
      .getProfileInfo()
      .then(p => !cancelled && setProfile(p))
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [identityApi]);

  const name = profile.displayName || 'Mon profil';
  if (!isOpen) return <SidebarItem icon={PersonIcon} to="/profile" text={name} />;
  return (
    <Link to="/profile" underline="none" className={classes.user}>
      <span className={classes.avatar} aria-hidden>
        {profile.displayName ? initials(profile.displayName) : <PersonIcon fontSize="small" />}
      </span>
      <span className={classes.text}>
        <div className={classes.name}>{name}</div>
        {profile.email && <div className={classes.email}>{profile.email}</div>}
      </span>
    </Link>
  );
};
